import { Mesh } from '@babylonjs/core';
export class PointCloudTree extends Mesh {
    root = null;
    constructor(name = 'pointCloudTree', scene) {
        super(name, scene);
    }
    initialized() {
        return this.root !== null;
    }
}
